import { api } from '@/lib/api'
import type { Product, ProductRequest, ProductUpdateRequest } from './types'

// ----- product (element) dictionary -----

export async function listProducts(activeOnly: boolean): Promise<Product[]> {
  const r = await api.get<Product[]>('/api/products', { params: { activeOnly } })
  return r.data
}

export async function createProduct(payload: ProductRequest): Promise<Product> {
  const r = await api.post<Product>('/api/products', payload)
  return r.data
}

export async function updateProduct(code: string, payload: ProductUpdateRequest): Promise<Product> {
  const r = await api.put<Product>(`/api/products/${code}`, payload)
  return r.data
}

export async function deleteProduct(code: string): Promise<void> {
  await api.delete(`/api/products/${code}`)
}

// ----- configuration composition (which products a configuration contains) -----

export async function listComposition(configurationCode: string): Promise<string[]> {
  const r = await api.get<string[]>(`/api/configurations/${configurationCode}/products`)
  return r.data
}

export async function setComposition(configurationCode: string, productCodes: string[]): Promise<void> {
  await api.put(`/api/configurations/${configurationCode}/products`, { productCodes })
}

// ----- product (element) form sections: which form sections an element renders -----

export async function setProductSections(productCode: string, ids: number[]): Promise<void> {
  await api.put(`/api/forms/product/${productCode}/sections`, { ids })
}
